/* eslint-disable react/style-prop-object */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './dealer-search-criteria.scss';
import DealerSearchInput from './dealer-search-input';
import DealerSearchParams from '../state/dealer-search-params';
import { FormattedMessage } from 'react-intl';
import KeyValuePair from '../../../../sharedmodules/state/key-value-pair';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import React from 'react';

const DealerSearchCriteria = (props) => (
    <section className="dealer-search-criteria">
        <div className="primary-criteria">
            <DealerSearchInput
                actions={props.actions}
                identifier="account"
                onInputChange={props.onDealerSearchInput}
                style="dealer-search-account"
                text="ACCOUNT_NUMBER"
                value={props.searchParams.account}
            />
        </div>
        <div className="separator">
            <FormattedMessage id="OR" />
        </div>
        <div className="secondary-criteria">
            <OptionsDropDown
                alwaysCallOnChange
                className="division-drop-down"
                isPlaceholderTranslated={false}
                isRequired={false}
                label="DIVISION"
                onChange={props.onDealerSearchDivisionInput}
                optionDisplayAttributes={['value']}
                optionKey="key"
                options={props.division}
                placeholder="SELECT"
                selectedValue={props.searchParams.division}
            />
            <DealerSearchInput
                actions={props.actions}
                identifier="name1"
                onInputChange={props.onDealerSearchInput}
                style="dealer-search-name"
                text="NAME"
                value={props.searchParams.name1}
            />
            <DealerSearchInput
                actions={props.actions}
                identifier="city"
                onInputChange={props.onDealerSearchInput}
                style="dealer-search-city"
                text="CITY"
                value={props.searchParams.city}
            />
        </div>
    </section>
);

DealerSearchCriteria.displayName = 'DealerSearchCriteria';
DealerSearchCriteria.propTypes = {
    actions: PropTypes.object.isRequired,
    division: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onDealerSearchDivisionInput: PropTypes.func.isRequired,
    onDealerSearchInput: PropTypes.func.isRequired,
    searchParams: PropTypes.instanceOf(DealerSearchParams).isRequired,
};

export default DealerSearchCriteria;
